import { ETheme } from "@/DependenciesV9";
import { NavCategoryItem, NavCategoryItemProps } from "@fluentui/react-nav-preview";

interface NavCategoryItemCustomProps extends NavCategoryItemProps {
  rcName?: string;
  theme?: ETheme;
}

const NavCategoryItemCustom = (props: NavCategoryItemProps & NavCategoryItemCustomProps) => {
  return <NavCategoryItem {...props}/>
};

export default NavCategoryItemCustom;